import { memo, useEffect, useState } from 'react';
import { Theme } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import { ActionModal } from '../../../components/Modal';
import { IUsersState } from '../users.slice';
import { UserForm } from '../../../components/form/user-form/user-form';
import { useUser } from '../../../components/form/user-form/use-user';
import { emptyUser } from '../../../models/empty-user';
import { validateUser } from '../../../models/validate-user';

const styles = (theme: Theme) => {
  return createStyles({
    root: {},
  });
};

export interface IAddUsersModalProps extends WithStyles<typeof styles> {
  customStyles?: any;
  open: boolean;
  handleClose: () => void;
  handleAddUser: (data: any) => void;
  selectUser: IUsersState;
}

const AddUsersModal = ({
  open,
  handleClose,
  handleAddUser,
  selectUser,
}: IAddUsersModalProps) => {
  const { updateUser, user, resetState } = useUser({ ...emptyUser });
  const { fieldErrors, hasErrors } = validateUser(user, [
    'contactNumber',
    'parentId',
  ]);
  const intl = useIntl();

  useEffect(() => {
    handleClose();
    resetState();
  }, [selectUser.loading]);

  const onClickActionButton = () => {
    if (!hasErrors) {
      const userData = {
        name: user.profile.name,
        email: user.email,
        password: user.password,
      };
      handleAddUser(userData);
    }
  };

  const onClose = () => {
    handleClose();
    resetState();
  };

  return (
    <ActionModal
      modalTitle={intl.formatMessage({
        id: 'add_admin',
      })}
      modalDescription={intl.formatMessage({
        id: 'add_admin_description',
      })}
      id="add-user-modal"
      open={open}
      isSingleButton
      handleClose={onClose}
      actinButtonOnClick={onClickActionButton}
      actinButtonLabel={intl.formatMessage({
        id: 'add_admin',
      })}
      actionButtonDisabled={hasErrors}
    >
      <UserForm
        fields={{
          name: {
            error: fieldErrors.name,
            required: true,
          },
          email: {
            error: fieldErrors.email,
            required: true,
          },
          password: {
            error: fieldErrors.password,
            required: true,
          },
        }}
        updateUser={updateUser}
        user={user}
      />
    </ActionModal>
  );
};

export default memo(withStyles(styles)(AddUsersModal));
